import { ITEM_DEFS } from './item-defs.js';

export const TOOL_TIER_SPEED = {
  wood: 2.1,
  stone: 3.1,
  gold: 5.3,
  iron: 4.3,
  diamond: 6.2
};

const TOOL_TIER_LEVEL = {
  wood: 1,
  stone: 2,
  iron: 3,
  gold: 4,
  diamond: 5
};

export const BLOCK_PREFERRED_TOOL = {
  1: 'shovel',
  2: 'shovel',
  3: 'axe',
  4: 'axe',
  5: 'pickaxe',
  6: 'axe',
  78: 'axe',
  79: 'axe',
  80: 'axe',
  81: 'axe',
  82: 'axe',
  83: 'axe',
  84: 'axe',
  85: 'axe',
  86: 'axe',
  87: 'axe',
  88: 'axe',
  89: 'axe',
  90: 'axe',
  91: 'axe',
  92: 'axe',
  93: 'axe',
  94: 'axe',
  95: 'axe',
  8: 'pickaxe',
  9: 'pickaxe',
  10: 'pickaxe',
  11: 'axe',
  12: 'axe',
  14: 'axe',
  15: 'axe',
  16: 'axe',
  17: 'axe',
  18: 'axe',
  19: 'axe',
  20: 'axe',
  21: 'pickaxe',
  22: 'pickaxe',
  23: 'pickaxe',
  24: 'pickaxe',
  25: 'pickaxe',
  26: 'shovel',
  27: 'shovel',
  28: 'pickaxe',
  29: 'pickaxe',
  30: 'pickaxe',
  31: 'pickaxe',
  32: 'pickaxe',
  33: 'pickaxe',
  34: 'pickaxe',
  35: 'pickaxe',
  36: 'pickaxe',
  37: 'pickaxe',
  38: 'pickaxe',
  39: 'pickaxe',
  40: 'pickaxe',
  41: 'shovel',
  42: 'pickaxe',
  44: 'pickaxe',
  45: 'pickaxe',
  47: 'pickaxe',
  48: 'pickaxe',
  49: 'shovel',
  58: 'pickaxe',
  59: 'pickaxe',
  60: 'pickaxe',
  61: 'pickaxe',
  62: 'pickaxe',
  63: 'pickaxe',
  65: 'axe',
  68: 'hoe',
  74: 'pickaxe',
  75: 'pickaxe',
  77: 'pickaxe',
  13: 'pickaxe'
};

const HARD_BLOCK_IDS = new Set([
  5, 8, 9, 10, 13,
  21, 22, 23, 24, 25,
  28, 29, 30, 31,
  32, 33, 34, 35, 36, 37, 39, 47, 48,
  42, 44, 45, 62, 63,
  74, 75, 77
]);

function isHardBlock(blockId) {
  return HARD_BLOCK_IDS.has(Number(blockId));
}

export function getMiningSpeed(itemId, blockId) {
  const item = ITEM_DEFS[itemId];
  const preferred = BLOCK_PREFERRED_TOOL[blockId];
  if (!item || item.kind !== 'tool') {
    return isHardBlock(blockId) ? 0.46 : 1.0;
  }
  if (item.toolType === 'sword' || item.toolType === 'bow' || item.toolType === 'shield') {
    return isHardBlock(blockId) ? 0.46 : 0.92;
  }
  if (item.toolType === 'shears') {
    return Number(blockId) === 4 ? 6.0 : 0.62;
  }

  const tierSpeed = TOOL_TIER_SPEED[item.tier] || 1.0;
  if (preferred && item.toolType === preferred) return tierSpeed;
  return Math.max(0.5, tierSpeed * 0.42);
}

export function canHarvestDrop(itemId, blockId) {
  const requiredTierMap = {
    5: 1,
    8: 2,
    9: 1,
    10: 3,
    13: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    28: 1,
    29: 1,
    30: 1,
    31: 5,
    32: 1,
    33: 1,
    34: 1,
    35: 1,
    36: 1,
    37: 3,
    39: 1,
    42: 1,
    44: 1,
    45: 1,
    47: 3,
    48: 1,
    62: 1,
    63: 1,
    74: 1,
    75: 2,
    77: 1
  };
  const requiredTier = requiredTierMap[Number(blockId)] || 0;
  if (requiredTier <= 0) return true;

  const item = ITEM_DEFS[itemId];
  if (!item || item.kind !== 'tool' || item.toolType !== 'pickaxe') return false;
  const level = TOOL_TIER_LEVEL[item.tier] || 0;
  return level >= requiredTier;
}

export function getDropItemId(blockId) {
  if (blockId === 7) return null;
  if (blockId === 69) return null;
  if (blockId === 4) return null;
  if (blockId === 5) return '28';
  if (blockId === 9) return 'coal';
  if (blockId === 10) return 'diamond_gem';
  if (blockId === 12) return 'torch';
  if (blockId === 17) return '16';
  if (blockId === 19) return '18';
  if (blockId === 49) return '2';
  if (blockId === 50 || blockId === 51 || blockId === 52 || blockId === 53) return null;
  if (blockId === 66) return 'berry';
  if (blockId === 67) return 'blueberry';
  if (blockId === 76) return 'aloe';
  if (blockId === 23) return null;
  if (blockId === 43) return null;
  if (blockId === 46) return null;
  if (blockId === 64) return null;
  if (blockId === 59) return '58';
  if (blockId === 61) return '60';
  if (blockId === 63) return '62';
  return String(blockId);
}
